import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { LocationPageHero } from '../../components/locations/LocationPageHero';
import { LocationHighlights } from '../../components/locations/LocationHighlights';
import { LocationSchedule } from '../../components/locations/LocationSchedule';
import { LocationContactForm } from '../../components/locations/LocationContactForm';
import { getLocationById } from '../../data/locations';
export function MidlandPage() {
  const location = getLocationById('midland');
  if (!location) {
    return <div data-id="element-805">Location not found</div>;
  }
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-806">
      <Header data-id="element-807" />

      <main className="pt-20" data-id="element-808">
        <LocationPageHero location={location} data-id="element-809" />
        <LocationHighlights highlights={location.highlights} locationName={location.name} data-id="element-810" />
        <LocationSchedule schedule={location.schedule} hasSchedule={location.hasSchedule} locationName={location.name} data-id="element-811" />
        <LocationContactForm preselectedLocationId={location.id} data-id="element-812" />
      </main>

      <Footer data-id="element-813" />
    </div>;
}